// extracted by mini-css-extract-plugin
export default {"inactive":"steps_inactive__ebRWy","form-control":"steps_form-control__KScUm","form-select":"steps_form-select__GnXyp","form-wrapper":"steps_form-wrapper__UC-yp"};